import {NgModule} from "@angular/core";
import {IntResizeObserverDirective} from "./resize-observer.directive";


@NgModule({
  declarations: [
    IntResizeObserverDirective
  ],
  exports: [
    IntResizeObserverDirective
  ]
})
export class IntResizeObserverModule {}
